import ReactModal from 'react-modal';
import React from 'react';
import styles from '@/styles/User.module.css';
import { Receipt } from '@desquared/wave-components-library';
import CUSTOM_STYLES from '@/utils/modalStyle';

export default function GiftReceipt({ showModal, setShowModal, receiptDetailsList, greeting, message }) {
  const _customStyles = {
    ...CUSTOM_STYLES,
    content: {
      ...CUSTOM_STYLES.content,
      backgroundColor: 'transparent',
      border: 'none',
      filter: 'none',
      maxWidth: '100%',
    },
  };

  return (
    showModal && (
      <ReactModal
        isOpen={showModal}
        onRequestClose={() => {
          setShowModal(false);
        }}
        style={_customStyles}
        contentLabel={'gift receipt modal'}
        ariaHideApp={false}
        shouldCloseOnOverlayClick={true}
        className={styles.modalContainer}
      >
        <Receipt greeting={greeting} message={message} showAlert={false} list={receiptDetailsList ?? []} />
      </ReactModal>
    )
  );
}
